"use strict";
/**
 * PageTitle Components Export
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTitle = void 0;
var PageTitle_1 = require("./PageTitle");
Object.defineProperty(exports, "PageTitle", { enumerable: true, get: function () { return PageTitle_1.PageTitle; } });
